import React, { FC, SVGProps } from "react";

const NodataImage: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
  return (
    <svg
      width={"440"}
      height="440"
      viewBox="0 0 440 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // className={cn("fill-[#0866FF]", className)}
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_17168_53726)">
        <g filter="url(#filter0_ii_17168_53726)">
          <rect
            x="107"
            y="238.913"
            width="226.549"
            height="141.732"
            fill="url(#paint0_linear_17168_53726)"
          />
        </g>
        <g filter="url(#filter1_iii_17168_53726)">
          <path
            d="M107.434 238.913H333.983L365.545 298.231C366.963 300.895 365.032 304.11 362.014 304.11H78.1158C75.0682 304.11 73.1401 300.838 74.6165 298.172L107.434 238.913Z"
            fill="#E4E4E4"
          />
        </g>
        <path
          d="M306.471 218.362H133.862L107.432 238.913H333.98L306.471 218.362Z"
          fill="url(#paint1_linear_17168_53726)"
        />
        <path
          d="M133.863 218.362L107.432 238.913H133.862L133.863 218.362Z"
          fill="#D1D1D1"
        />
        <path
          d="M351.8 201.472L377.904 216.36C379.342 217.181 379.218 219.293 377.693 219.939L332.918 238.913L306.37 218.362L350.083 201.346C350.645 201.127 351.276 201.174 351.8 201.472Z"
          fill="url(#paint2_linear_17168_53726)"
        />
        <mask
          id="mask0_17168_53726"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="306"
          y="201"
          width="73"
          height="38"
        >
          <path
            d="M351.8 201.472L377.904 216.36C379.342 217.181 379.218 219.293 377.693 219.939L332.918 238.913L306.37 218.362L350.083 201.346C350.645 201.127 351.276 201.174 351.8 201.472Z"
            fill="url(#paint3_linear_17168_53726)"
          />
        </mask>
        <g mask="url(#mask0_17168_53726)">
          <rect
            width="119.224"
            height="75.4917"
            transform="matrix(0.92055 -0.390625 0.389974 0.920826 289.004 255.56)"
            fill="#D9D9D9"
          />
        </g>
        <path
          d="M88.2004 201.472L62.1078 216.354C60.6675 217.175 60.7948 219.292 62.323 219.935L107.435 238.913L133.63 218.362L89.9167 201.346C89.3548 201.127 88.7242 201.174 88.2004 201.472Z"
          fill="url(#paint4_linear_17168_53726)"
        />
        <mask
          id="mask1_17168_53726"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="61"
          y="201"
          width="73"
          height="38"
        >
          <path
            d="M88.2004 201.472L62.1078 216.354C60.6675 217.175 60.7948 219.292 62.323 219.935L107.435 238.913L133.63 218.362L89.9167 201.346C89.3548 201.127 88.7242 201.174 88.2004 201.472Z"
            fill="url(#paint5_linear_17168_53726)"
          />
        </mask>
        <g mask="url(#mask1_17168_53726)">
          <rect
            width="119.224"
            height="75.4916"
            transform="matrix(0.920173 0.391513 -0.390861 0.92045 36.4141 207.023)"
            fill="#D9D9D9"
          />
        </g>
        <path
          d="M306.371 218.362L333.982 238.913H306.373L306.371 218.362Z"
          fill="#D1D1D1"
        />
        <rect
          opacity="0.5"
          x="291.75"
          y="113.75"
          width="122.5"
          height="50.5"
          rx="11.25"
          stroke="#D9D9D9"
          strokeWidth="1.5"
        />
        <rect
          opacity="0.15"
          x="307"
          y="133"
          width="32"
          height="4"
          rx="2"
          fill="#1B1B1B"
        />
        <rect
          opacity="0.1"
          x="307"
          y="141"
          width="72"
          height="4"
          rx="2"
          fill="#727272"
        />
        <rect
          opacity="0.5"
          x="423.75"
          y="113.75"
          width="122.5"
          height="50.5"
          rx="11.25"
          stroke="#D9D9D9"
          strokeWidth="1.5"
        />
        <rect
          opacity="0.5"
          x="26.75"
          y="113.75"
          width="122.5"
          height="50.5"
          rx="11.25"
          stroke="#D9D9D9"
          strokeWidth="1.5"
        />
        <rect
          opacity="0.15"
          x="42"
          y="133"
          width="32"
          height="4"
          rx="2"
          fill="#1B1B1B"
        />
        <rect
          opacity="0.1"
          x="42"
          y="141"
          width="72"
          height="4"
          rx="2"
          fill="#727272"
        />
        <rect
          opacity="0.5"
          x="158.75"
          y="113.75"
          width="122.5"
          height="50.5"
          rx="11.25"
          stroke="#D9D9D9"
          strokeWidth="1.5"
        />
        <path
          d="M190.757 146H188.957V133.13H190.919L197.939 144.128H197.327V133.13H199.127V146H197.165L190.145 135.002H190.757V146ZM206.158 146.288C205.282 146.288 204.496 146.084 203.8 145.676C203.116 145.268 202.576 144.704 202.18 143.984C201.796 143.264 201.604 142.448 201.604 141.536C201.604 140.612 201.796 139.79 202.18 139.07C202.576 138.35 203.116 137.786 203.8 137.378C204.496 136.97 205.282 136.766 206.158 136.766C207.058 136.766 207.85 136.97 208.534 137.378C209.23 137.786 209.77 138.35 210.154 139.07C210.55 139.79 210.748 140.606 210.748 141.518C210.748 142.442 210.55 143.264 210.154 143.984C209.77 144.704 209.23 145.268 208.534 145.676C207.85 146.084 207.058 146.288 206.158 146.288ZM206.176 144.758C206.716 144.758 207.184 144.62 207.58 144.344C207.976 144.068 208.288 143.69 208.516 143.21C208.744 142.718 208.858 142.16 208.858 141.536C208.858 140.888 208.744 140.33 208.516 139.862C208.3 139.382 207.988 139.004 207.58 138.728C207.184 138.452 206.716 138.314 206.176 138.314C205.636 138.314 205.162 138.452 204.754 138.728C204.358 139.004 204.046 139.382 203.818 139.862C203.602 140.33 203.494 140.888 203.494 141.536C203.494 142.16 203.602 142.718 203.818 143.21C204.046 143.69 204.358 144.068 204.754 144.344C205.162 144.62 205.636 144.758 206.176 144.758ZM223.488 146V143.714L223.47 143.642V141.698C223.47 141.026 223.356 140.438 223.128 139.934C222.9 139.418 222.582 139.022 222.174 138.746C221.778 138.458 221.316 138.314 220.788 138.314C220.26 138.314 219.792 138.452 219.384 138.728C218.976 139.004 218.658 139.382 218.43 139.862C218.202 140.342 218.088 140.9 218.088 141.536C218.088 142.16 218.202 142.718 218.43 143.21C218.67 143.69 218.994 144.068 219.402 144.344C219.822 144.62 220.302 144.758 220.842 144.758C221.322 144.758 221.76 144.65 222.156 144.434C222.564 144.206 222.894 143.9 223.146 143.516C223.41 143.132 223.566 142.688 223.614 142.184L223.992 142.526C224.052 143.234 223.932 143.876 223.632 144.452C223.344 145.016 222.924 145.466 222.372 145.802C221.832 146.126 221.196 146.288 220.464 146.288C219.66 146.288 218.934 146.084 218.286 145.676C217.65 145.268 217.14 144.71 216.756 144.002C216.384 143.282 216.198 142.46 216.198 141.536C216.198 140.612 216.384 139.79 216.756 139.07C217.14 138.35 217.65 137.786 218.286 137.378C218.934 136.97 219.654 136.766 220.446 136.766C221.07 136.766 221.628 136.898 222.12 137.162C222.612 137.414 223.014 137.768 223.326 138.224C223.65 138.68 223.848 139.202 223.92 139.79H223.47V133.04H225.27V146H223.488ZM235.128 146H233.49V144.236L233.436 143.822V140.474C233.436 139.778 233.226 139.232 232.806 138.836C232.386 138.428 231.81 138.224 231.078 138.224C230.118 138.224 229.278 138.62 228.558 139.412L227.514 138.296C228.558 137.276 229.794 136.766 231.222 136.766C232.014 136.766 232.698 136.916 233.274 137.216C233.862 137.516 234.318 137.942 234.642 138.494C234.966 139.034 235.128 139.676 235.128 140.42V146ZM230.466 146.288C229.83 146.288 229.266 146.168 228.774 145.928C228.294 145.676 227.916 145.334 227.64 144.902C227.364 144.47 227.226 143.978 227.226 143.426C227.226 142.502 227.58 141.782 228.288 141.266C229.008 140.738 229.974 140.474 231.186 140.474H233.598V141.752H231.348C230.628 141.752 230.064 141.896 229.656 142.184C229.26 142.46 229.062 142.85 229.062 143.354C229.062 143.81 229.218 144.182 229.53 144.47C229.854 144.746 230.286 144.884 230.826 144.884C231.342 144.884 231.804 144.77 232.212 144.542C232.62 144.314 232.95 144.002 233.202 143.606C233.454 143.21 233.598 142.754 233.634 142.238L234.192 142.544C234.192 143.276 234.03 143.924 233.706 144.488C233.394 145.052 232.956 145.496 232.392 145.82C231.84 146.132 231.198 146.288 230.466 146.288ZM242.433 146H240.399C239.691 146 239.157 145.814 238.797 145.442C238.449 145.07 238.275 144.524 238.275 143.804V134.552H240.075V143.57C240.075 143.87 240.147 144.098 240.291 144.254C240.435 144.41 240.651 144.488 240.939 144.488H242.433V146ZM242.325 138.566H236.691V137.054H242.325V138.566ZM251.551 146H249.913V144.236L249.859 143.822V140.474C249.859 139.778 249.649 139.232 249.229 138.836C248.809 138.428 248.233 138.224 247.501 138.224C246.541 138.224 245.701 138.62 244.981 139.412L243.937 138.296C244.981 137.276 246.217 136.766 247.645 136.766C248.437 136.766 249.121 136.916 249.697 137.216C250.285 137.516 250.741 137.942 251.065 138.494C251.389 139.034 251.551 139.676 251.551 140.42V146ZM246.889 146.288C246.253 146.288 245.689 146.168 245.197 145.928C244.717 145.676 244.339 145.334 244.063 144.902C243.787 144.47 243.649 143.978 243.649 143.426C243.649 142.502 244.003 141.782 244.711 141.266C245.431 140.738 246.397 140.474 247.609 140.474H250.021V141.752H247.771C247.051 141.752 246.487 141.896 246.079 142.184C245.683 142.46 245.485 142.85 245.485 143.354C245.485 143.81 245.641 144.182 245.953 144.47C246.277 144.746 246.709 144.884 247.249 144.884C247.765 144.884 248.227 144.77 248.635 144.542C249.043 144.314 249.373 144.002 249.625 143.606C249.877 143.21 250.021 142.754 250.057 142.238L250.615 142.544C250.615 143.276 250.453 143.924 250.129 144.488C249.817 145.052 249.379 145.496 248.815 145.82C248.263 146.132 247.621 146.288 246.889 146.288Z"
          fill="#0A0F29"
          fillOpacity="0.25"
        />
        <rect
          opacity="0.5"
          x="-105.25"
          y="113.75"
          width="122.5"
          height="50.5"
          rx="11.25"
          stroke="#D9D9D9"
          strokeWidth="1.5"
        />
        <circle cx="120" cy="74" r="4" fill="url(#paint6_linear_17168_53726)" />
        <circle cx="80" cy="104" r="2" fill="url(#paint7_linear_17168_53726)" />
        <circle cx="367" cy="89" r="2" fill="url(#paint8_linear_17168_53726)" />
        <circle
          cx="312"
          cy="186"
          r="4"
          fill="url(#paint9_linear_17168_53726)"
        />
        <circle
          cx="331"
          cy="48"
          r="8"
          fill="url(#paint10_linear_17168_53726)"
        />
        <circle
          cx="96"
          cy="200"
          r="8"
          fill="url(#paint11_linear_17168_53726)"
        />
        <path
          d="M0 108L440 108"
          stroke="#F0E9E1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDasharray="2 6"
        />
        <path
          d="M0 169L440 169"
          stroke="#F0E9E1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDasharray="2 6"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_17168_53726"
          x="107"
          y="238.913"
          width="226.547"
          height="145.732"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="16"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_innerShadow_17168_53726"
          />
          <feOffset dy="104" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.907568 0 0 0 0 0.907568 0 0 0 0 0.907568 0 0 0 1 0"
          />
          <feBlend
            mode="multiply"
            in2="shape"
            result="effect1_innerShadow_17168_53726"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_innerShadow_17168_53726"
          />
          <feOffset dy="76" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.961361 0 0 0 0 0.961361 0 0 0 0 0.961361 0 0 0 1 0"
          />
          <feBlend
            mode="multiply"
            in2="effect1_innerShadow_17168_53726"
            result="effect2_innerShadow_17168_53726"
          />
        </filter>
        <filter
          id="filter1_iii_17168_53726"
          x="74.1094"
          y="238.913"
          width="291.91"
          height="65.1973"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.824235 0 0 0 0 0.824235 0 0 0 0 0.824235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_17168_53726"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_17168_53726"
            result="effect2_innerShadow_17168_53726"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_17168_53726"
            result="effect3_innerShadow_17168_53726"
          />
        </filter>
        <linearGradient
          id="paint0_linear_17168_53726"
          x1="220.274"
          y1="238.913"
          x2="220.274"
          y2="380.645"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.681688" stopColor="#E4E4E4" />
          <stop offset="1" stopColor="#E4E4E4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_17168_53726"
          x1="220.706"
          y1="244.228"
          x2="220.706"
          y2="218.362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2D2D2" />
          <stop offset="1" stopColor="#E7E7E7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_17168_53726"
          x1="347.609"
          y1="187.246"
          x2="347.609"
          y2="238.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#E4E4E4" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_17168_53726"
          x1="347.609"
          y1="187.246"
          x2="347.609"
          y2="238.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#E4E4E4" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_17168_53726"
          x1="92.3909"
          y1="187.246"
          x2="92.3909"
          y2="238.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#E4E4E4" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_17168_53726"
          x1="92.3909"
          y1="187.246"
          x2="92.3909"
          y2="238.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset="1" stopColor="#E4E4E4" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_17168_53726"
          x1="122.75"
          y1="68"
          x2="118.25"
          y2="78.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#CECECE" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_17168_53726"
          x1="81.375"
          y1="101"
          x2="79.125"
          y2="106.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#CECECE" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_17168_53726"
          x1="368.375"
          y1="86"
          x2="366.125"
          y2="91.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#CECECE" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_17168_53726"
          x1="314.75"
          y1="180"
          x2="310.25"
          y2="190.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#CECECE" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_17168_53726"
          x1="336.5"
          y1="36"
          x2="327.5"
          y2="57.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#CECECE" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_17168_53726"
          x1="101.5"
          y1="188"
          x2="92.5"
          y2="209.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#CECECE" />
        </linearGradient>
        <clipPath id="clip0_17168_53726">
          <rect width="440" height="440" rx="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NodataImage;
